import "core-js/modules/es.error.cause.js";
import { __decorate } from "tslib";
import { Component, PropSync } from "vue-property-decorator";
import { service } from "@modules/newCommunity/setup";
import { mixins } from "vue-class-component";
import commonMixins from "@mixins/commonNewMixins";
let templateTitleDialog = class templateTitleDialog extends mixins(commonMixins) {
  constructor() {
    super(...arguments);
    this.inputValue = "";
    this.loading = false;
    this.form = {
      title: ""
    };
    // contentChange() {
    //   this.$emit("input", this.inputValue);
    // }
  }
  onOpen() {
    // console.log("onopen");
    this.form.title = "";
    // (this.$refs.form as any).clearValidate();
  }
  async validatorTitle(rule, value, callback) {
    // console.log("validator", this.basicData, this.basicData.cover, this.basicData.introduce);
    let res = null;
    res = await service.questionnaireTemplateCheckTitleUnique({
      title: value,
      id: "",
      communityId: this.VX_comtyId,
      questionnaireType: "QUESTIONNAIRE",
      questionnaireSource: "DOCTOR",
      questionnaireProperty: "ACTIVITY_INTERACT"
    });
    // console.log("formtemplateCheckTitleUnique", res);
    if (res) {
      callback();
    } else {
      callback(Error("名称已存在"));
    }
  }
  confirm() {
    this.$refs["form"].validate(async valid => {
      if (valid) {
        this.visible = false;
        this.$emit("success", this.form.title);
      } else {
        return false;
      }
    });
  }
};
__decorate([PropSync("modalVisible", {
  type: Boolean
})], templateTitleDialog.prototype, "visible", void 0);
templateTitleDialog = __decorate([Component({
  name: "templateTitleDialog",
  components: {}
})], templateTitleDialog);
export default templateTitleDialog;